// extracted by mini-css-extract-plugin
export default {"root":"AutoLogin_root__WkPLg","verticalCenter":"AutoLogin_verticalCenter__ruMxX"};